export const STAGE_PAGE_WIDTH_CLASS =
  'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8';

export const STAGE_PAGE_CONTENT_WIDTH_CLASS = 'max-w-7xl mx-auto';